import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../reactRoute/RouteConstants'

const StillSection = () => {
    return (
        <div className="flex flex-col w-full items-center gap-[32px] px-[4vw] py-[64px]">
            <img src="images/avatarGroup.png" className='max-w-[120px]' alt="" />
            <div className="flex flex-col gap-[12px] text-center">
                <h4 className='text-[#1e232e] font-[700] text-[20px]'>
                    Still have questions?
                </h4>
                <p className='text-[#475467] text-[16px]'>
                    Can’t find the answer you’re looking for? Please chat to our friendly team.
                </p>
            </div>
            <Link to={ROUTES.djContact} className='flex items-center gap-[24px] font-[500] w-fit px-[24px] py-[12px] bg-[#F02E49] text-[#fff] rounded-[8px]'>
                Get in Touch
            </Link>
        </div>
    )
}

export default StillSection